import type { User } from '@gitbook/api-client';
import { getUserDisplayName } from '@gitbook/app-database';

/**
 * Display the user's display name, with a special indicator if it's the current user.
 */
export function UserDisplayName(props: { user: User | null }) {
    return <>{getUserDisplayName(props.user)}</>;
}
